// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Universe Dungeon Dimensions - Main Export
 * 
 * Aggregates all configuration for the Dungeon Dimensions universe.
 * A realm of eldritch horror and impossible mathematics from Terry Pratchett's Discworld.
 */

import { starSystems, starPositions } from './StarSystemsConfig';
import { warpGates, warpGatePositions } from './WarpGatesConfig';
import { DungeonDimensionsAliensPlanets } from './AliensConfig';

export const universeDungeonDimensions = {
  id: 'dungeon-dimensions',
  starSystems,
  starPositions,
  warpGates,
  warpGatePositions,
  aliens: DungeonDimensionsAliensPlanets,
};

export default universeDungeonDimensions;
